import { useContext, useEffect } from 'react'
import { ReadGridColumnWidthContext } from '../context/column-width-context'

const FORMATTER = Intl.NumberFormat()

export function ReadGridRowNumCell({ parent, columnIndex, rowIndex, style }) {
  const columnWidthContext = useContext(ReadGridColumnWidthContext)
  const currentWidth = style?.width

  useEffect(() => {
    if (rowIndex >= 100_000) {
      const newWidth = String(rowIndex).length * 10
      columnWidthContext.updateColumnWidth(columnIndex, newWidth - currentWidth)
      parent.recomputeGridSize({ columnIndex, rowIndex })
    }
  }, [rowIndex, currentWidth])

  return (
    <div className="read-grid-cell row-num-cell" style={style}>
      {FORMATTER.format(rowIndex)}
    </div>
  )
}
